import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { UserContext } from '../../../../context/UserContext';
import { Category, ProductSuggestion } from '../../../../types';
import useBusinessInformation from '../../../../helperHooks/useBusinessInformation';
import ActionsMenu from './ActionsMenu';
import { currencyDisplay } from '../../../../helpers/helpers';

export const MobileRowMainContent = ({ data }: { data: ProductSuggestion }) => (
  <Box>
    <Typography variant="body1" fontWeight={600}>
      {data.name || ''}
    </Typography>
  </Box>
);

export const MobileRowExpandableContent = ({
  data,
  categories,
  isLoading,
  handleDeleteClick,
  handleAddClick,
  handleDuplicateClick,
}: {
  data: ProductSuggestion;
  categories: Category[];
  isLoading: boolean;
  handleDeleteClick: (id: string) => void;
  handleAddClick: (id: string) => void;
  handleDuplicateClick: (id: string) => void;
}) => {
  const { t } = useTranslation();
  const { user, locale } = useContext(UserContext);
  const { currencyISOCode } = useBusinessInformation();

  const category = useMemo(
    () =>
      categories?.find((newCategory) => newCategory.Id === data.categoryId)?.Name || 'Top Level',
    [user, data]
  );

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.5rem',
          alignItems: 'flex-start',
          marginRight: '2rem',
          width: '100%',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '0.3rem' }}>
          <Typography variant="body1">{t('screens.products.sidekick.description')}:</Typography>
          <Typography variant="body1" fontWeight={600}>
            {data.description || ''}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '0.3rem' }}>
          <Typography variant="body1">{t('screens.products.sidekick.category')}:</Typography>
          <Typography variant="body1" fontWeight={600}>
            {category}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '0.3rem' }}>
          <Typography variant="body1">{t('screens.products.sidekick.price')}:</Typography>
          <Typography variant="body1" fontWeight={600}>
            {currencyDisplay(data?.price, locale, currencyISOCode)}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-end',
        }}
      >
        <ActionsMenu
          objectId={data?.placeholderId}
          isLoading={isLoading}
          handleDeleteClick={handleDeleteClick}
          handleAddClick={handleAddClick}
          handleDuplicateClick={handleDuplicateClick}
        />
      </Box>
    </Box>
  );
};
